import { locales, Locale } from "../../locales"

export const getBrowserLang = (): Locale | null => {
  if (typeof navigator === "undefined") return null

  // Dynamically get the list of valid locales from locales.ts, excluding "default"
  const validLocales = locales.filter((locale): locale is Locale => locale !== "default")

  const lang = navigator?.language?.split("-")[0]
  if (validLocales.includes(lang as Locale)) return lang as Locale

  return null
}
